// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"HeaderMenu_menuPaper__3lDmm","menuList":"HeaderMenu_menuList__11ud1","menuItem":"HeaderMenu_menuItem__28Vbq"};